import component from "../../legacy/UnavailableNoop"

export default component
